// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__39BaN","top":"Main_top__1XDFC","vault-header":"Main_vault-header__1U_R0","centre":"Main_centre__3_Ol_","assets-container":"Main_assets-container__ojUB_"};